import {
  //   Apiv2DeleteRequest,
  Apiv2GetRequest,
  //   Apiv2PostRequest,
  //   Apiv2PutRequest,
  //   Apiv2PostMultipart,
} from '../../api-v2';
// import moment from 'moment-mini';
// import { showNotif } from '../notification';

export const state = {
  data: {
    loading_eor: false,
    loading_pti: false,
    loading_hutang: false,
    loading_stock: false,
    loading_chart: false,
    total_eor_submission: 0,
    total_pti_submission: 0,
    total_hutang: 0,
    total_stok_container: 0,
    today_container_in: 0,
    today_container_out: 0,
    last_month_stock: 0,
    today_month_stock: 0,
    chartData: {
      series: [
        {
          name: 'Container In',
          data: [],
        },
        {
          name: 'Container Out',
          data: [],
        },
        {
          name: 'Repair',
          data: [],
        },
        {
          name: 'PTI',
          data: [],
        },
      ],
      chartoptions: {
        chart: {
          height: 350,
          type: 'area',
          toolbar: {
            show: false,
          },
        },
        colors: ['#556ee6', '#f1b44c', '#f44336', '#03a9f4'],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.45,
            opacityTo: 0.05,
            stops: [20, 100, 100, 100],
          },
        },
        xaxis: {
          categories: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ],
        },
        markers: {
          size: 3,
          strokeWidth: 3,

          hover: {
            size: 4,
            sizeOffset: 2,
          },
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
        },
      },
    },
  },
};

export const mutations = {
  changeUserDashboard(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getEorSubmission({ commit }, payload) {
    commit('changeUserDashboard', {
      loading_eor: true,
    });

    const result = await Apiv2GetRequest(`dashboard/eor-submission`, payload);
    commit('changeUserDashboard', {
      loading_eor: false,
    });

    if (!result.error) {
      commit('changeUserDashboard', {
        ...result.data.object,
        loading_eor: false,
      });
    }
  },

  async getPtiSubmission({ commit }, payload) {
    commit('changeUserDashboard', {
      loading_pti: true,
    });

    const result = await Apiv2GetRequest(`dashboard/pti-submission`, payload);
    commit('changeUserDashboard', {
      loading_pti: false,
    });

    if (!result.error) {
      commit('changeUserDashboard', {
        ...result.data.object,
        loading_pti: false,
      });
    }
  },

  async getTotalHutang({ commit }, payload) {
    commit('changeUserDashboard', {
      loading_hutang: true,
    });

    const result = await Apiv2GetRequest(`dashboard/total-hutang`, payload);
    commit('changeUserDashboard', {
      loading_hutang: false,
    });

    if (!result.error) {
      commit('changeUserDashboard', {
        ...result.data.object,
        loading_hutang: false,
      });
    }
  },

  async getTotalStokContainer({ commit }, payload) {
    commit('changeUserDashboard', {
      loading_stock: true,
    });

    const result = await Apiv2GetRequest(
      `dashboard/total-stock-container`,
      payload
    );
    commit('changeUserDashboard', {
      loading_stock: false,
    });

    if (!result.error) {
      commit('changeUserDashboard', {
        ...result.data.object,
        loading_stock: false,
      });
    }
  },

  async getChartPrinciple({ commit, state }) {
    commit('changeUserDashboard', {
      loading_chart: true,
    });

    const { data } = state;
    const result = await Apiv2GetRequest(`dashboard/chart`);
    commit('changeUserDashboard', {
      loading_chart: false,
    });

    if (!result.error) {
      commit('changeUserDashboard', {
        today_container_in: !result.error
          ? result.data.object.today_container_in
          : 0,
        today_container_out: !result.error
          ? result.data.object.today_container_out
          : 0,
        last_month_stock: !result.error
          ? result.data.object.last_month_stock
          : 0,
        today_month_stock: !result.error
          ? result.data.object.today_month_stock
          : 0,
        chartData: {
          ...data.chartData,
          series: [
            {
              name: 'Container In',
              data: !result.error ? result.data.object.container_in : [],
            },
            {
              name: 'Container Out',
              data: !result.error ? result.data.object.container_out : [],
            },
            {
              name: 'Repair',
              data: !result.error ? result.data.object.container_repair : [],
            },
            {
              name: 'PTI',
              data: !result.error ? result.data.object.container_pti : [],
            },
          ],
        },
        loading_chart: false,
      });
    }
  },
};
